// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flyte-panel[data-v-63ac7b8a]{height:250px;transition:width height .35 ease}.flyte-panel .card-body[data-v-63ac7b8a]{position:relative;font-size:15px}.flyte-panel .card-body p[data-v-63ac7b8a]{transition:font-size .35s ease}", ""]);
// Exports
module.exports = exports;
